<!--徳茵定制电流均值-->
<template>
	<div>
		<treeBody>
			<virtualDeviceTree slot="tree" :dataList="virtualDeviceList" @checkItem="$store.deviceStore.commit('setNowVirtualDevice',$event)"
			 :autoSelectMethod='autoSelectMethod'>
			</virtualDeviceTree>
			<div slot="body">
				<!--表格显示数据-->
				<infoList ref="infoList" style="height: 100%;" :columns='columns' :dataList="dataList" :pageLen='dataList.length'
				 :totalSize="dataList.length" :fillAll="true" :showIndex='false'></infoList>
			</div>
		</treeBody>
	</div>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	export default {
		components: {
			treeBody,
			infoList,
			virtualDeviceTree,
		},
		props: {},
		data() {
			return {
				columns: [{
					name: '数据项',
					key: 'item'
				}, {
					name: '值',
					key: 'value',
					getTdStyleMethod(c, r, item) {
						return item != undefined && (item + "").startsWith(' ') ? {
							color: 'red'
						} : {}
					}
				}],
			}
		},
		created() {},
		mounted() {
			debugPage = this
		},
		destroyed() {},
		computed: {
			nowDevice() {
				return this.$store.deviceStore.state.nowVirtualDevice
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowUnitArchivesTree() {
				//当前单位可以查看的台账设备树
				if (isempty(this.nowUnit)) {
					return undefined
				}
				return this.$store.archivesStore.getters.getArchivesTreeByUnitId(this.nowUnit.id)
			},
			nowUnitAllArchivesList() {
				if (this.nowUnitArchivesTree == undefined) {
					return []
				}
				return this.addArchivesListInfo(treeToList(this.nowUnitArchivesTree, 'next', item => item.entityName == 'AppClassType').filter(
					item => item.entityName ==
					"AppEquipmentArchives"))
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [data]
			},
			getBoxVariableList() {
				//获取指定id的汇流箱的发电量变量列表
				if (this.nowDevice == undefined) {
					return []
				}
				var vl = this.$store.variableStore.getters.getVariableTree(this.nowDevice.no, [262, 263, 264, 265, 266, 267, 268,
					269,
					270, 271, 272, 273, 274, 275, 276, 277
				])
				if (vl.length != 0) {
					return vl[0].next
				}
				return []
			},
			getArchivesBindInfo() {
				return pkid => {
					return this.nowArchivesBindMap[pkid]
				}
			},
			unitSetting() {
				return this.nowUnitAllArchivesList.filter(item => item.typeCode == "UnitSetting")[0]
			},
			nowArchivesBindMap() {
				//当前台账设备列表的绑定信息map
				return this.$store.archivesStore.getters.getBindInfoMapByArchivesIdList(this.nowUnitAllArchivesList.map(item =>
					item.id))
			},
			dataList() {
				if (this.nowDevice == undefined) {
					return []
				}
				var list = [{
					item: '是否告警',
					value: '否'
				}, {
					item: '总支路数',
					value: 0
				}, {
					item: '均值电流',
					value: '--'
				}, {
					item: '报警值',
					value: getValueIfNoNull(this.unitSetting, {}).UnitSetting___CurrentWarnValue
				}]
				var rtList = this.realTimeValueStore.getters.getValue(this.getBoxVariableList.map(item => item.fromName))
				//计算平均值
				var countA = 0
				var countYX = 0
				for (var i = 0, len = this.getBoxVariableList.length; i < len; i++) {
					var item = this.getBoxVariableList[i]
					var value = this.$historyTools.isNull(rtList[i]) ? undefined : parseFloat(rtList[i])
					if (value != undefined) {
						countYX++
						countA += value
					}
				}
				list[2].value = cutDigital(countA / countYX)
				//显示变量的值，显示的是差值
				for (var i = 0, len = this.getBoxVariableList.length; i < len; i++) {
					var item = this.getBoxVariableList[i]
					var value = this.$historyTools.isNull(rtList[i]) ? undefined : parseFloat(rtList[i])
					list.push({
						item: item.name,
						value: value == undefined ? ' -- ' : cutDigital(value - list[2].value)
					})
				}
				//支路总数
				list[1].value = list.length - 4
				//告警情况
				for (var i = 4, len = list.length; i < len; i++) {
					var item = list[i]
					if (Math.abs(item.value) > list[3].value) {
						item.value = ' ' + item.value + " "
						list[0].value = ' 是 '
					}
				}
				return list
			}
		},
		watch: {
			nowUnitAllArchivesList(nv, ov) {
				this.$store.archivesStore.commit("getBindInfoMapByArchivesIdList", nv.map(item => item.id).join(','))
			},
			getBoxVariableList(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov.map(item => item.fromName))
				this.realTimeValueStore.commit("addKeys", nv.map(item => item.fromName))
			}
		},
		methods: {
			autoSelectMethod(item, index) {
				if (this.nowDevice != undefined) {
					return this.nowDevice.id == item.id && this.nowDevice.type == item.type
				} else {
					return item.type == 'virtualDevice'
				}
			},
			addArchivesListInfo(archivesList) {
				//增加时间字符串
				var dateTools = new Date()
				for (var i = 0, len = archivesList.length; i < len; i++) {
					var item = archivesList[i]
					dateTools.setTime(item.createTime)
					item.createTimeText = dateTools.formatByTime()
				}
				//按照时间排序
				archivesList = archivesList.sort((a, b) => b.createTime - a.createTime)
				//增加属性值
				var list = []
				for (var i = 0, len = archivesList.length; i < len; i++) {
					var item = archivesList[i]
					this.$store.archivesStore.getters.getArchivesInfoById(item.id).forEach(it => {
						if (it.valueType == 7) {
							//如果是枚举,先找枚举列表
							var enumList = this.$store.enumStore.getters.getEnumByEnumCode(it.enumCode)
							if (!isempty(enumList.next)) {
								var Enum = enumList.next.find(e => {
									return e.pkid == it.value
								})
								item[it.typeCode + "___" + it.propertyCode] = Enum == undefined ? '' : Enum.itemText
							}
						} else {
							if (it.valueType == 6) {
								item[it.typeCode + "___" + it.propertyCode] = it.value == 1 ? "是" : "否"
							} else {
								item[it.typeCode + "___" + it.propertyCode] = it.value
							}
						}
					})
					list.push(item)
				}
				return list
			},
		}
	}
</script>

<style scoped>

</style>
